import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { BubbleSpinLoader } from 'react-css-loaders';
import Progress from '../components/Progress';
import QuestionItem from './QuestionItem';

import ContentLoader, { Rect } from 'react-content-loader';

@inject('QuestionStore') 
@observer
export default class QuestionList extends Component {
  componentWillMount() {
    const { QuestionStore } = this.props;
    const { params } = this.props.match;
    QuestionStore.setQuestionId(params.questionId)
		QuestionStore.fetchData();
	}

  render() {
    const { QuestionStore } = this.props;
    return (
  		<section id="content-question" className="content">
        { QuestionStore.isSending &&
          <div>
            <Progress/>
            <section className="container-loader">
              <BubbleSpinLoader color="#aaa" size={5}/>
            </section>
          </div>
        }

        { QuestionStore.isLoading && (
          <div className="loader">
            <div>
              <ContentLoader height={38} speed={1} primaryColor={'#cdcdcd'} secondaryColor={'#e3e3e3'}>
                <Rect x={9.5} y={11} height={6.5} radius={0} width={40} />
                <Rect x={9.5} y={23} height={7.5} radius={0} width={68} />
              </ContentLoader>
            </div>

            <div>
              <ContentLoader height={38} speed={1} primaryColor={'#cdcdcd'} secondaryColor={'#e3e3e3'}>
                <Rect x={9.5} y={11} height={6.5} radius={0} width={30} />
                <Rect x={9.5} y={23} height={7.5} radius={0} width={100} />
              </ContentLoader>
            </div>

            <div>
              <ContentLoader height={38} speed={1} primaryColor={'#cdcdcd'} secondaryColor={'#e3e3e3'}>
                <Rect x={9.5} y={11} height={6.5} radius={0} width={50} />
                <Rect x={9.5} y={23} height={7.5} radius={0} width={85} />
              </ContentLoader>
            </div>
          </div>
        )}

        { QuestionStore.existQuestions == 0 && !QuestionStore.isLoading &&
          <p className="no-results">Ainda não existem perguntas para este segmento.</p>
        }

        { !QuestionStore.isLoading &&
          <ul className="list-replies">
            {QuestionStore.questions.map((item) => {
              return(
                <QuestionItem key={item.id} item={item} opened={item.id === QuestionStore.questionId} />
              );
            })}
          </ul>
        }
  		</section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/QuestionList.js